<!-- biome-ignore-all lint/a11y/noStaticElementInteractions: the role and tabindex are applied only when an onClick handler is present, which Biome cannot resolve statically -->
<script setup lang="ts">
  import {
    clickableClass,
    iconBaseClass,
    rotationClass,
    sizeClass,
  } from './FontIcon.css';
  import { computed, useAttrs } from 'vue';
  import { FontIconSize, type FontIconProps } from './FontIcon.types';

  defineOptions({
    inheritAttrs: false,
  });

  const props = withDefaults(defineProps<FontIconProps>(), {
    rotation: 0,
    size: FontIconSize.Default,
  });

  const attrs = useAttrs();

  const rotationKey = computed(
    () => String(props.rotation) as '0' | '90' | '180' | '270',
  );

  const isClickable = computed(() => !!attrs.onClick);

  const onKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      (event.currentTarget as HTMLElement).click();
    }
  };

  const iconClasses = computed(() => [
    'tundr-icon',
    `ti-${props.iconName}`,
    iconBaseClass,
    rotationClass[rotationKey.value],
    sizeClass[props.size],
    { [clickableClass]: isClickable.value },
  ]);
</script>

<template>
  <i
    :id="id"
    :data-testid="testId"
    :title="title"
    :class="iconClasses"
    :role="isClickable ? 'button' : undefined"
    :tabindex="isClickable ? 0 : undefined"
    :aria-label="ariaLabel"
    :aria-hidden="isClickable ? undefined : 'true'"
    v-bind="$attrs"
    @keydown="isClickable ? onKeydown($event) : undefined"
  />
</template>
